import React from "react";

import { makeStyles } from "@material-ui/core";
import clsx from "clsx";

import { LogoProps } from "./types";

const useStyles = makeStyles(theme => ({
  // these styles may be extended via 'className' prop
  text: {
    fill: theme.palette.grey[900],
  },
  pattern: {
    fill: theme.palette.secondary.main,
  },
}));

const Logo: React.FC<LogoProps> = ({ rootClass, textClass, patternClass }) => {
  const classes = useStyles();

  return (
    <svg
      width="115"
      height="21"
      viewBox="0 0 115 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={rootClass}
    >
      <path
        d="M39.4069 3V17.7701H36.0438V11.9106H31.3631V17.7701H28V3H31.3631V8.65146H36.0091V3H39.4069Z"
        className={clsx(classes.text, textClass)}
      />
      <path
        d="M51.2989 7.22998V17.8048H48.1091V16.7993C47.5544 17.5968 46.4796 18.0822 45.0927 18.0822C42.9431 18.0822 41.1401 16.5566 41.1401 13.7136V7.22998H44.2952V13.2628C44.2952 14.5803 45.1274 15.1698 46.1328 15.1698C47.3117 15.1698 48.1091 14.511 48.1091 12.9855V7.22998H51.2989Z"
        className={clsx(classes.text, textClass)}
      />
      <path
        d="M64.4392 12.5C64.4392 15.6551 62.1508 18.0821 59.3771 18.0821C57.9556 18.0821 56.9154 17.5967 56.222 16.7993V17.8047H53.0669V3H56.222V8.20073C56.9154 7.40328 57.9556 6.91788 59.3771 6.91788C62.1855 6.91788 64.4392 9.34489 64.4392 12.5ZM61.284 12.5C61.284 10.9051 60.2439 9.93431 58.7877 9.93431C57.3315 9.93431 56.2913 10.9398 56.2913 12.5C56.2913 14.0602 57.3315 15.0657 58.7877 15.0657C60.2439 15.0657 61.284 14.0949 61.284 12.5Z"
        className={clsx(classes.text, textClass)}
      />
      <path
        d="M65.2021 12.5C65.2021 9.34485 67.5945 6.91785 70.7843 6.91785C72.8299 6.91785 74.6328 7.99266 75.5689 9.62223L72.7952 11.2171C72.4485 10.489 71.6857 10.0383 70.7496 10.0383C69.3627 10.0383 68.3573 11.0438 68.3573 12.5C68.3573 13.9562 69.3627 14.9616 70.7496 14.9616C71.6857 14.9616 72.4485 14.5109 72.7952 13.7828L75.5689 15.3777C74.6675 17.0419 72.8646 18.1168 70.7843 18.1168C67.5598 18.0821 65.2021 15.6551 65.2021 12.5Z"
        className={clsx(classes.text, textClass)}
      />
      <path
        d="M87.2536 7.22988V17.8047H86.1788V15.4124C85.2773 17.0073 83.6824 18.0474 81.6368 18.0474C78.655 18.0474 76.1587 15.6551 76.1587 12.5346C76.1587 9.41419 78.6204 7.02185 81.6368 7.02185C83.6477 7.02185 85.2773 8.062 86.1788 9.65689V7.26455H87.2536V7.22988ZM86.1441 12.5C86.1441 10.0036 84.2025 7.99265 81.6715 7.99265C79.1751 7.99265 77.1988 9.96893 77.1988 12.5C77.1988 14.9963 79.1751 17.0073 81.6715 17.0073C84.2025 17.0073 86.1441 15.031 86.1441 12.5Z"
        className={clsx(classes.text, textClass)}
      />
      <path
        d="M101.019 12.5C101.019 15.6204 98.557 18.0127 95.5406 18.0127C93.495 18.0127 91.8654 16.9726 90.9986 15.343V21H89.9585V7.22989H90.9986V9.69156C91.8654 8.062 93.495 7.02186 95.5406 7.02186C98.5917 6.98718 101.019 9.37952 101.019 12.5ZM99.9786 12.5C99.9786 10.0036 98.0023 7.99266 95.5059 7.99266C93.0096 7.99266 91.0333 9.96894 91.0333 12.5C91.0333 14.9963 93.0096 17.0073 95.5059 17.0073C98.0023 17.0073 99.9786 15.031 99.9786 12.5Z"
        className={clsx(classes.text, textClass)}
      />
      <path
        d="M114.124 12.5C114.124 15.6204 111.663 18.0127 108.646 18.0127C106.6 18.0127 104.971 16.9726 104.104 15.343V21H103.064V7.22989H104.104V9.69156C104.971 8.062 106.6 7.02186 108.646 7.02186C111.663 6.98718 114.124 9.37952 114.124 12.5ZM113.084 12.5C113.084 10.0036 111.108 7.99266 108.611 7.99266C106.115 7.99266 104.139 9.96894 104.139 12.5C104.139 14.9963 106.115 17.0073 108.611 17.0073C111.108 17.0073 113.084 15.031 113.084 12.5Z"
        className={clsx(classes.text, textClass)}
      />
      <path d="M1.00049 0H0.000488281V21H1.00049V0Z" className="pattern" />
      <path
        d="M3.00049 0H2.00049V12H13.0005V11H3.00049V0Z"
        className={clsx(classes.pattern, patternClass)}
      />
      <path
        d="M5.00049 0H4.00049V10H13.0005V9H5.00049V0Z"
        className={clsx(classes.pattern, patternClass)}
      />
      <path
        d="M7.00049 0H6.00049L6.00049 8H13.0005V7H7.00049V0Z"
        className={clsx(classes.pattern, patternClass)}
      />
      <path
        d="M2.00049 13V21H3.00049V14H4.00049V21H4.99728V14H6.00049V21H7.00049V14H13.0005V13H2.00049Z"
        className={clsx(classes.pattern, patternClass)}
      />
      <path
        d="M15.0005 0H14.0005V21H15.0005V0Z"
        className={clsx(classes.pattern, patternClass)}
      />
      <path
        d="M17.0239 0H16.0239V21H17.0239V0Z"
        className={clsx(classes.pattern, patternClass)}
      />
      <path
        d="M19.0005 0H18.0005V21H19.0005V0Z"
        className={clsx(classes.pattern, patternClass)}
      />
      <path
        d="M21.0005 0H20.0005V21H21.0005V0Z"
        className={clsx(classes.pattern, patternClass)}
      />
    </svg>
  );
};
export default Logo;
